<template>
  <div class="text-center">
      <h1 class="text-2xl mb-4">Oops... You seem lost, but don't fret, I can help you.</h1>
      <router-link class="text-indigo-600 underline" to="/home">Go to HomePage</router-link>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>